// src/types/bookings/BookingFinancials.ts
var SETTLEMENT_CURRENCY = "EGP";
function getBookingSettlementCurrency(booking) {
  return booking?.metadata?.settlement_currency ?? SETTLEMENT_CURRENCY;
}
function getGuestPaidAmount(booking) {
  const meta = booking.metadata;
  const egp = meta?.amount_paid_egp ?? meta?.chargeable_total_egp;
  if (egp != null) {
    return { amount: egp, currency: meta?.settlement_currency ?? "EGP" };
  }
  return {
    amount: Number(booking.total_amount) || 0,
    currency: meta?.listing_currency ?? SETTLEMENT_CURRENCY
  };
}
function getInvitationAmount(invitation) {
  if (invitation.total_amount == null) return null;
  const amount = Number(invitation.total_amount);
  if (!Number.isFinite(amount)) return null;
  return { amount, currency: invitation.settlement_currency ?? SETTLEMENT_CURRENCY };
}
function getModificationSettlementCurrency(modification) {
  const newMetadata = modification?.pricing_snapshot?.new_metadata;
  return newMetadata?.settlement_currency ?? SETTLEMENT_CURRENCY;
}
function getModificationDelta(modification) {
  return {
    amount: Number(modification.delta_amount_egp) || 0,
    currency: getModificationSettlementCurrency(modification)
  };
}

export {
  SETTLEMENT_CURRENCY,
  getBookingSettlementCurrency,
  getGuestPaidAmount,
  getInvitationAmount,
  getModificationSettlementCurrency,
  getModificationDelta
};
